/**
 * TVG-83 / TVG-312: An admin-managed entry on the Sales Manager, Show around or
 * lead source list.
 *
 * These are free-text values (not linked to a real user account). Inactive
 * entries stay on historic records but are no longer offered on new ones.
 */
export type EventRoleNameRole = 'sales_manager' | 'show_around' | 'lead_source';

export interface EventRoleName {
  id: number;
  role: EventRoleNameRole;
  name: string;
  is_active: boolean;
  created_at?: string;
  updated_at?: string;
}

/**
 * TVG-312: the id/name pair an event embeds for the name-list entry it points
 * at (`sales_manager_name_ref` / `show_around_name_ref`). Present whether or not
 * the entry is still active.
 */
export interface EventRoleNameRef {
  id: number;
  name: string;
}

/**
 * TVG-312: the refs an event currently holds for the two ownership lists.
 */
export interface OwnershipNameRefs {
  sales_manager?: EventRoleNameRef | null;
  show_around?: EventRoleNameRef | null;
}

/**
 * TVG-312: build the dropdown choices for a name list, keeping the entry the
 * record already holds even once it has been retired. A retired entry drops out
 * of the API's selectable list, so without this the field would render blank on
 * a past record and a save of the other fields would silently clear it. The
 * suffix mirrors the contact Source field.
 */
export function withRetainedName(
  entries: EventRoleName[],
  ref: EventRoleNameRef | null | undefined,
): { value: any; label: string }[] {
  const choices = entries.map((entry) => ({ value: entry.id, label: entry.name }));

  if (ref && !choices.some((choice) => String(choice.value) === String(ref.id))) {
    choices.push({ value: ref.id, label: `${ref.name} (retired)` });
  }

  return choices;
}
